<template>
  <form class="container-fluid">
    <!-- <LuxMisc /> -->
    <div class="luxMisc">
      <div class="row">
        <!-- CID -->
        <div class="col-md-4">
          <label style="color:#0892D0;" for="CID">Device CID</label>
          <input
            type="number"
            name="CID"
            id="CID"
            placeholder="CID"
            v-model="regparams.CID"
            class="form-control form-control-lg"
          />
        </div>
        <!-- Charge Cycle -->
        <div class="col-md-4">
          <label style="color:#0892D0;" for="charge_cycle">Charge Cycle</label>
          <input
            type="number"
            name="Charge Cycle"
            id="charge_cycle"
            placeholder="Charge Cycle"
            v-model="regparams.Charge"
            class="form-control"
          />
        </div>
        <!-- Exptd. Charge Cycle -->
        <div class="col-md-4">
          <label style="color:#0892D0;" for="E_charge_cycle"
            >Exptd. Charge Cycle</label
          >
          <input
            type="number"
            name="E_charge_cycle"
            id="E_charge_cycle"
            placeholder="Expected Charge Cycle"
            v-model="regparams.ExptdCharge"
            class="form-control form-control-lg"
          />
        </div>
      </div>
      <div class="row">
        <!-- LAC -->
        <div class="col-md-4">
          <label style="color:#0892D0;" for="LAC">LAC</label>
          <input
            type="number"
            name="LAC"
            id="LAC"
            placeholder="LAC"
            v-model="regparams.LAC"
            class="form-control form-control-lg"
          />
        </div>
        <!-- MCC -->
        <div class="col-md-4">
          <label style="color:#0892D0;" for="MCC">MCC</label>
          <input
            type="number"
            name="MCC"
            id="MCC"
            placeholder="MCC"
            v-model="regparams.MCC"
            class="form-control form-control-lg"
          />
        </div>
        <!-- MNC -->
        <div class="col-md-4">
          <label style="color:#0892D0;" for="MNC">MNC</label>
          <input
            type="number"
            name="MNC"
            id="MNC"
            placeholder="MNC"
            v-model="regparams.MNC"
            class="form-control form-control-lg"
          />
        </div>
      </div>
      <div class="row">
        <!-- PAP -->
        <div class="col-md-4">
          <label style="color:#0892D0;" for="PAP">PAP</label>
          <input
            type="number"
            name="PAP"
            id="PAP"
            placeholder="PAP"
            v-model="regparams.PAP"
            class="form-control form-control-lg"
          />
        </div>
        <!-- PAT -->
        <div class="col-md-4">
          <label style="color:#0892D0;" for="PAT">PAT</label>
          <input
            type="number"
            name="PAT"
            id="PAT"
            placeholder="PAT"
            v-model="regparams.PAT"
            class="form-control form-control-lg"
          />
        </div>
        <!-- PSC -->
        <div class="col-md-4">
          <label style="color:#0892D0;" for="PSC">PSC</label>
          <input
            type="number"
            name="PSC"
            id="PSC"
            placeholder="PSC"
            v-model="regparams.PSC"
            class="form-control form-control-lg"
          />
        </div>
      </div>
      <div class="row">
        <!-- Radio -->
        <div class="col-md-4">
          <label style="color:#0892D0;" for="Radio">Radio</label>
          <input
            type="text"
            name="Radio"
            id="Radio"
            placeholder="Radio"
            v-model="regparams.Radio"
            class="form-control form-control-lg"
          />
        </div>
        <!-- SIM -->
        <div class="col-md-4">
          <label style="color:#0892D0;" for="SIM">SIM</label>
          <input
            type="text"
            name="SIM"
            id="SIM"
            placeholder="SIM"
            v-model="regparams.SIM"
            class="form-control form-control-lg"
          />
        </div>
        <!-- Button -->
        <div class="container-fluid">
          <div class="button_style">
            <button
              type="submit"
              class="btn btn-outline-primary btn-lg"
              @click="back"
            >
              Back
            </button>
            <button
              type="button"
              class="btn btn-primary btn-lg"
              @click="submit"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { isEmpty } from "element-ui/src/utils/util";
export default {
  name: "LuxMisc",
  components: {},
  data() {
    return {
      GetLuxOnboardingStates: this.$store.getters.getLuxOnboardingStates,
      GetLuxPaymentStates: this.$store.getters.getLuxPaymentStates,
      StoreLuxOnboardingStatus: this.$store.state.luxOnboardingStatus,
      StoreLuxPaymentStatus: this.$store.state.luxPaymentStatus,
      regparams: {
        CID: "",
        Charge: "",
        ExptdCharge: "",
        LAC: "",
        MCC: "",
        MNC: "",
        PAP: "",
        PAT: "",
        PSC: "",
        Radio: "",
        SIM: ""
      },
      validateError: false
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    validateReg() {
      let errors = [];
      for (let [field, value] of Object.entries(this.regparams)) {
        value = value + "";
        if (value !== null && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "CID":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "CID cannot be empty.";
            }
            break;
          case "Charge":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "Charge cannot be empty.";
            }
            break;
          case "ExptdCharge":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "ExptdCharge cannot be empty.";
            }
            break;
          case "LAC":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "LAC cannot be empty.";
            }
            break;
          case "MCC":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "MCC cannot be empty.";
            }
            break;
          case "MNC":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "MNC cannot be empty.";
            }
            break;
          case "PAP":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "PAP cannot be empty.";
            }
            break;
          case "PAT":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "PAT cannot be empty.";
            }
            break;
          case "PSC":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "PSC cannot be empty.";
            }
            break;
          case "Radio":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "Radio cannot be empty.";
            }
            break;
          case "SIM":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "SIM cannot be empty.";
            }
            break;
          default:
            break;
        }
        this.errorsResult = errors;
      }
      var errorLength = Object.keys(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        this.validateError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      } else {
        this.validateError = false;
      }
    },
    submit() {
      this.validateReg();
      if (this.validateError === false) {
        let MiscData = {
          PSC: this.regparams.PSC,
          PAT: this.regparams.PAT,
          MNC: this.regparams.MNC,
          ChgCycle: this.regparams.Charge,
          ExptdChgCyl: this.regparams.ExptdCharge,
          SIM: this.regparams.SIM,
          Radio: this.regparams.Radio,
          MCC: this.regparams.MCC,
          PAP: this.regparams.PAP,
          CID: this.regparams.CID,
          LAC: this.regparams.LAC
        };
        let allParams = {
          deviceId: this.StoreLuxOnboardingStatus.deviceId,
          serialNumbers: this.StoreLuxOnboardingStatus.serialNumbers,
          paymentType: this.StoreLuxPaymentStatus.paymentType,
          Version: this.StoreLuxPaymentStatus.deviceVersion,
          CLoad: this.StoreLuxPaymentStatus.cLoadValue,
          MiscData
        };
        console.log("Here are your data:", allParams);

        const LuxHTTP = this.$httpUtils.LUXHTTP;
        let url = `/devices`;

        LuxHTTP.post(url, allParams)
          .then(response => {
            console.log("response", response);
            this.showSuccessMsg({ message: "Device setup successfully!" });
            window.history.back();
            this.$store.state.luxCount = 1;
          })
          .catch(error => {
            this.showErrorMsg({ message: "Error occured at our end!" });
          });
      } else {
        console.log("Validate data first");
      }
    },
    back() {
      this.$store.state.luxCount = 2;
      this.GetLuxOnboardingStates.serialNumbers = [];
      this.GetLuxOnboardingStates.deviceId = "";
      this.GetLuxPaymentStates.paymentType = "";
      this.GetLuxPaymentStates.cLoadValue = "";
      this.GetLuxPaymentStates.deviceVersion = "";
    }
  }
};
</script>

<style scoped>
.button_style {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 80%;
  font-family: sans-serif;
  width: 100%;
  margin: auto;
  padding: 24px 0;
}
.luxMisc {
  font-family: sans-serif;
}
.luxMisc label {
  font-size: 12px;
  font-weight: 500;
  margin-top: 12px;
}
.luxMisc input {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/luxOnboarding/LuxMisc.vue